(ns profile.information
  (:require
   [reagent.core :as r]
   [very.re-frame.core :as rf :refer [<sub >evt]]
   [css.core :refer [defstyled get-theme]]
   [css.form :as form]
   [css.icons :as icon]
   [css.vars :as vars]
   [cljss.core :as cljss]
   [main.common :as common]
   [util.core :refer [abbrev-full-name-initials to-local-time]]))

(defstyled pi-grid :div
  {:display "grid"
   :grid-template-columns "35fr 65fr"
   ::cljss/media {[[:max-width "768px"]]
                  {:grid-template-columns "3fr 7fr"}
                  [[:max-width "500px"]]
                  {:grid-template-columns "2fr 8fr"}}})

(defstyled client-name :h2
  {:font-size "24px"
   :color "#282828"
   :line-height "42px"
   :margin-bottom "1rem"})

(defstyled edit-text-s :span
  {:color "#666"
   :font-size "13px"})

(defstyled edit-icon-s :span
  {:margin-right ".5rem"})

(defstyled profile-image-s :img
  {:max-width "100%"
   :border-radius "50%"
   :margin-bottom "1rem"})

(defstyled profile-image-wrapper-s :div
  {:padding "0 2rem 0 0"
   :text-align "center"})

(defstyled no-image-s :div
  {:position "relative"
   :border-radius "50%"
   :width "100%"
   :height "auto"
   :padding-top "100%"
   :background "gray"
   :margin-bottom "1rem"})

(defstyled no-image-text-s :div
  {:color "white"
   :font-size "3rem"
   :position "absolute"
   :top "0"
   :bottom "0"
   :left "0"
   :right "0"
   :margin "0"
   :display "flex"
   :align-items "center"
   :justify-content "center"})

(defstyled form-text-s :span
  {:font-size "1.5rem"
   :margin "0 .5rem"})

(defstyled form-text-period-s :span
  {:font-size "1.5rem"
   :margin "0 .3rem"})

(defstyled form-children-s :div
  {:display "flex"
   :justify-content "center"
   :margin-top "4rem"
   :flex-direction "column"})

(defstyled child-row-s :div
  {:display "grid"
   :grid-gap "30px"
   :grid-template-columns "1fr 1fr 1fr"
   :align-items "center"
   :justify-content "center"
   :margin-bottom "3rem"
   :&:last-child {:margin-bottom "0"}
   ::cljss/media {[[:max-width "768px"]]
                  {:grid-template-columns "1fr"
                   :grid-template-rows "1fr 1fr 1fr"
                   :margin-bottom "2.5rem"
                   :padding-bottom "2.5rem"
                   :border-bottom (str "1px solid " vars/border-light)
                   :&:last-child {:border-bottom "none"
                                  :padding-bottom "0"
                                  :margin-bottom "0"}}}})

(defstyled location-wrapper-s :div
  {:display "flex"
   :flex-direction "row"
   :justify-content "center"
   :align-items "center"
   :margin-bottom "4rem"
   ::cljss/media {[[:max-width "768px"]]
                  {:justify-content "flex-start"}}})

(defstyled location-marker-inactive-s :div
  {:width "12px"
   :height "12px"
   :background "white"
   :border "1px solid"
   :border-color (get-theme :primary)
   :border-radius "12px"
   :margin-right "1rem"
   :&:last-child {:margin-right "0"}})

(defstyled location-marker-active-s :div
  {:width "12px"
   :height "12px"
   :background (get-theme :primary)
   :border "1px solid"
   :border-color (get-theme :primary)
   :border-radius "12px"
   :margin-right "1rem"
   :&:last-child {:margin-right "0"}})

(defstyled photo-edit-s :button
  {:align-items "center"
   :display "flex"
   :justify-content "center"
   :border "none"
   :padding "0"
   :background "none"
   :border-bottom "1px solid transparent"
   :transition "border .25s ease-in"
   :cursor "pointer"
   :&:hover {:border-color vars/gray}
   :&:focus {:outline (str "1px dotted " vars/gray)
             :outline-offset "4px"}})

(defstyled personal-information-s :section {})

(defn personal-information-section-header [editable?]
  (if editable?
    [common/profile-section-header {:link #(rf/>evt [:profile/navigate-to-context :edit-personal-information])
                                    :text "Edit"
                                    :title "Personal information"}]
    [common/profile-section-header {:title "Personal information"}]))

(defn personal-information [{:keys [name retirement-age spouse children-count phone full-address photo-url] :as info} error]
  [personal-information-s
   (personal-information-section-header (not (and error (nil? info))))
   [pi-grid
    [profile-image-wrapper-s
     (if photo-url
       [profile-image-s {:src photo-url}]
       [no-image-s [no-image-text-s (abbrev-full-name-initials name)]])
     [:div {:style {:display "grid" :grid-template-columns "max-content" :justify-content "center"}}
      [photo-edit-s {:on-click #(>evt [:load-uploadcare])}
       [edit-icon-s [icon/pencil]]
       [edit-text-s "Edit Photo"]]]]
    (if (and error (nil? info))
      [:div "Your information could not be loaded. Please contact your advisor to ensure your account setup is complete"]
      [:div
       [client-name name]
       [common/data-row {:label "Retirement age:"
                         :value retirement-age}]
       [common/data-row {:label "Partner:"
                         :value (:name spouse)}]
       [common/data-row {:label "Number of children:"
                         :value children-count}]
       (when (some some? [retirement-age (:name spouse) children-count]) [common/divider-s])
       [common/data-row {:label "Phone:"
                         :value phone}]
       [common/data-row {:label "Address:"
                         :value full-address}]
       (when (some empty? [retirement-age (:name spouse) children-count full-address])
         [common/complete-button {:text "Complete Personal Information"
                                  :margin "1rem 0 0"
                                  :on-click #(rf/>evt [:profile/navigate-to-context :edit-personal-information])}])])]])

(defn form-location-indicator [location]
  [location-wrapper-s
   (for [x (range location)]
     [location-marker-active-s {:key (str "lma" x)}])
   (for [y (range (- 3 location))]
     [location-marker-inactive-s {:key (str "lmi" y)}])])

(defn form-step-my-info [{:keys [dob on-change retired name field change-page]}]
  [common/form-s {:key 0 :on-submit (fn [e]
                                      (.preventDefault e)
                                      (.stopPropagation e)
                                      (change-page 1))}
   [common/form-header-s
    [common/form-subtitle-s "My personal info"]
    [form-location-indicator 1]
    [common/form-title-s (str name ", let's start by learning a little more about you.")]]
   [common/form-row-s
    [form-text-s "I was born"]
    [common/form-input-date :past {:name "dob"
                                   :on-change #(on-change :dob (.. % -target -value))
                                   :required true
                                   :default-value dob}]
    [form-text-period-s "."]
    [form-text-s "I am "]
    [common/form-select-wrapper-s
     [common/form-select-s {:on-change #(on-change :retired (= (.. % -target -value) "true")) :default-value retired :required true}
      [:option {:value true} "Retired"]
      [:option {:value false} "Not Retired"]]
     [common/form-select-icon-s [icon/chevron]]]
    [form-text-period-s "."]]
   (if-not retired
     [:div
      [common/form-row-s
       [form-text-s "My occupation is"]
       [field "text" [:occupation] {:required true}]
       [form-text-s "and I work for"]
       [field "text" [:employer] {:required true}]
       [form-text-period-s "."]]
      [common/form-row-s
       [form-text-s "I plan to retire at age"]
       [field "number" [:retirement-age] {:required true}]
       [form-text-period-s "."]]])
   [form/button-row-s
    [form/secondary-button-s {:type "button" :on-click #(>evt [:profile/navigate-to-context :view-profile])} "Cancel"]
    [form/button {:type "submit"} "Next"]]])

(defn form-step-family [{:keys [on-change marital-status spouse children-count children field change-page]}]
  [common/form-s  {:key 1 :on-submit (fn [e]
                                       (.preventDefault e)
                                       (.stopPropagation e)
                                       (change-page 2))}
   [common/form-header-s
    [common/form-subtitle-s "My personal info"]
    [form-location-indicator 2]
    [common/form-title-s "Next, tell us about your family."]]
   [common/form-row-s
    [form-text-s "My status is"]
    [common/form-select-wrapper-s
     [common/form-select-s {:on-change #(on-change [:marital-status] (.. % -target -value))
                            :default-value marital-status
                            :required true}
      [:option {:value "Single"} "Single"]
      [:option {:value "Widowed"} "Widowed"]
      [:option {:value "Divorce-or-separated"} "Divorced-or-separated"]
      [:option {:value "Domestic-partnership"} "Partnership"]
      [:option {:value "Married"} "Married"]]
     [common/form-select-icon-s [icon/chevron]]]
    [form-text-s "with"]
    [field "number" [:children-count] {:required true :min 0 :max 99}]
    [form-text-s "child(ren)."]]
   (when (contains? #{"Married" "Domestic-partnership"} marital-status)
     [:div
      [common/form-row-s
       [form-text-s "My partner's name is"]
       [field "text" [:spouse :first-name] {:required true}]
       [form-text-s ""]
       [field "text" [:spouse :last-name] {:required true}]]
      [common/form-row-s
       [form-text-s "and was born"]
       [common/form-input-date :past {:name "spouse-dob"
                                      :default-value (to-local-time (:dob spouse) "YYYY-MM-DD")
                                      :required true
                                      :on-change #(on-change [:spouse :dob] (.. % -target -value))}]
       [form-text-period-s "."]]
      [common/form-row-s
       [form-text-s "They are"]
       [common/form-select-wrapper-s
        [common/form-select-s {:on-change #(on-change [:spouse :retired] (= (.. % -target -value) "true"))
                               :default-value (:retired spouse)
                               :required true}
         [:option {:value true} "Retired"]
         [:option {:value false} "Not Retired"]]
        [common/form-select-icon-s [icon/chevron]]]
       [form-text-period-s "."]]
      (if-not (:retired spouse)
        [:div
         [common/form-row-s
          [form-text-s "Their occupation is"]
          [field "text" [:spouse :occupation] {:required true}]
          [form-text-s "at"]
          [field "text" [:spouse :employer] {:required true}]
          [form-text-period-s "."]]
         [common/form-row-s
          [form-text-s "They plan to retire at age"]
          [field "number" [:spouse :retirement-age] {:required true}]
          [form-text-period-s "."]]])])

   (when (> children-count 0)
     (into [form-children-s]
      (for [x (range children-count) :let [child (get children x)]]
        [child-row-s
         [:input {:type "hidden" :value (:id child)}]
         [form/input-row-s {:margin "0"}
          [form/input-label-s "Child's first name"]
          [form/input {:default-value (:first-name child)
                       :on-change #(on-change [:children] (assoc children x (assoc child :first-name (.. % -target -value))))
                       :type "text"
                       :label? true
                       :name "firstName"
                       :required true}]]
         [form/input-row-s {:margin "0"}
          [form/input-label-s "Child's last name"]
          [form/input {:default-value (:last-name child)
                       :on-change #(on-change [:children] (assoc children x (assoc child :last-name (.. % -target -value))))
                       :type "text"
                       :label? true
                       :name "lastName"
                       :required true}]]
         [form/input-row-s {:margin "0"}
          [form/input-label-s "DOB (YYYY-MM-DD)"]
          [form/past-date {:on-change #(on-change [:children] (assoc children x (assoc child :dob (.. % -target -value))))
                           :default-value (to-local-time (:dob child) "YYYY-MM-DD")
                           :label? true
                           :required true
                           :name "dob"}]]])))
   [form/button-row-s
    [form/secondary-button-s {:type "button" :on-click #(change-page 0)} "Back"]
    [form/button {:type "submit"} "Next"]]])

(defn form-step-address [{:keys [field form-values change-page]}]
  [common/form-s  {:key 2 :on-submit (fn [e]
                                       (.preventDefault e)
                                       (>evt [:update-personal-information @form-values]))}
   [common/form-header-s
    [common/form-subtitle-s "My personal info"]
    [form-location-indicator 3]
    [common/form-title-s "Finally, please enter your address."]]
   [common/form-row-s
    [form-text-s "Street:"]
    [field "text" [:street] {:required true}]]
   [common/form-row-s
    [form-text-s "City:"]
    [field "text" [:city] {:required true}]]
   [common/form-row-s
    [form-text-s "State:"]
    [field "text" [:state] {:required true}]
    [form-text-s "Postal:"]
    [field "number" [:postal-code] {:required true}]]
   [form/button-row-s
    [form/secondary-button-s {:type "button" :on-click #(change-page 1)} "Back"]
    [form/button {:type "submit"} "Done"]]])

(defn personal-information-form [values]
  (let [form-page (r/atom 0)
        form-values (r/atom values)
        field (fn field-inner
                ([type name] (field-inner type name {}))
                ([type name props]
                 [(if (= type "number") common/form-input-number-s common/form-input-s)
                  (merge {:type type
                          :name name
                          :default-value (get-in @form-values name)
                          :on-change #(swap! form-values assoc-in name (.. % -target -value))}
                         props)]))]
    (fn [values]
      [common/form-page-s
        (condp = @form-page
          0 [form-step-my-info {:on-change #(swap! form-values assoc % %2)
                                :retired (:retired @form-values)
                                :name (:name @form-values)
                                :dob (:dob @form-values)
                                :field field
                                :change-page #(reset! form-page %)}]

          1 [form-step-family {:on-change #(swap! form-values assoc-in % %2)
                               :marital-status (:marital-status @form-values)
                               :spouse (:spouse @form-values)
                               :children-count (:children-count @form-values)
                               :children (:children @form-values)
                               :field field
                               :change-page #(reset! form-page %)}]

          2 [form-step-address {:field field
                                :form-values form-values
                                :change-page #(reset! form-page %)}])])))
